// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"9d415f5c","382":"b5170748","392":"9510e7b3","419":"13879d13","504":"ce15239e"}[chunkId] + ".chunk.css";
};